<template>
  <div class="login">
    <ModalAccount ref="ModalAccount" :account="listAccount" @action="selectAccount"></ModalAccount>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-0">
            <!-- {{ siteConfig }} -->
            <v-card-text>
              <!-- <router-link to="/" class="text-deco">
                <div class="pb-4">
                  <v-img width="250" :src="siteConfig.logo" class="mx-auto"></v-img>
                </div>
              </router-link> -->
              <a class="text-deco" :href="homepage">
                <div class="pb-4">
                  <v-img width="250" :src="siteConfig.logo" class="mx-auto"></v-img>
                </div>
              </a>
              <div class="text-center text-subtitle-1 font-weight-bold black--text">
                Silahkan masuk ke akun Anda
              </div>
              <div class="text-subtitle-2 py-5">
                <span class="black--text">Belum punya akun?</span>
                <router-link :to="{ name: 'register' }">
                  <span class="font-weight-bold pl-2 black--text ">Daftar di sini</span>
                </router-link>
              </div>
              <v-alert v-model="alerts.show" v-if="alerts.show" dense color="red lighten-1" class="white--text"
                dismissible>
                {{ alerts.message }}
              </v-alert>
              <v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
                <div>
                  <div class="text-subtitle-2 black--text pb-1">No. Hp</div>
                  <v-text-field color="black" autocomplete="true" :rules="usernameRules"
                    @focus="() => (fieldErrors.username = '')" :error-messages="fieldErrors.username" v-model="username"
                    validate-on-blur single-line outlined class="color-black rounded-lg" height="40"
                    dense></v-text-field>
                </div>
                <div>
                  <div class="text-subtitle-2 black--text pb-1">Password</div>
                  <v-text-field @click:append="showPassword" color="black" :type="passwordType" :rules="passwordRules"
                    @focus="() => (fieldErrors.password = '')" :error-messages="fieldErrors.password" v-model="password"
                    validate-on-blur single-line outlined class="color-black rounded-lg password-field" height="40"
                    dense :append-icon="passwordIcon" hide-details="auto"></v-text-field>
                  <v-row>
                    <v-col cols="6" class="pt-1">
                      <v-checkbox label="Ingat saya" color="primary" class="small-check mt-0"></v-checkbox>
                    </v-col>
                    <v-col cols="6" class="pt-2 text-right text-body-2">
                      <router-link to="/ubah-password" class="text-deco grey--text text--darken-1">
                        <div>Lupa Password?</div>
                      </router-link>
                    </v-col>
                  </v-row>
                </div>
                <div class="pt-5">
                  <v-btn v-if="isAttempting" x-large depressed color="black" class="col-12 rounded-lg white--text">
                    <div class="subtitle-2">Sedang Diproses ...</div>
                  </v-btn>
                  <v-btn v-else x-large depressed color="black" class="col-12 rounded-lg white--text" type="submit">
                    <div class="subtitle-2">Masuk</div>
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ModalAccount from "@/views/store/login/ModalChooseAccount";

export default {
  components: {
    ModalAccount
  },
  data() {
    return {
      homepage: process.env.VUE_APP_HOMEPAGE,
      username: "",
      password: "",
      passwordType: "password",
      passwordIcon: "mdi-eye",
      usernameRules: [v => !!v || "Nomor Handphone tidak boleh kosong"],
      passwordRules: [v => !!v || "Password tidak boleh kosong"],
      listAccount: []
    };
  },
  computed: {
    ...mapState("kiriminaja", [
      "siteConfig",
    ]),
    ...mapState("auth", ["isAttempting", "alerts", "fieldErrors"]),
  },
  async beforeMount() {
    await this.getSiteConfig()
    // console.log("siteconf", this.siteConfig.favicon)
    var link = await document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = await 'image/x-icon';
    link.rel = await 'shortcut icon';
    link.href = await this.siteConfig.favicon;
    await document.getElementsByTagName('head')[0].appendChild(link);
    // console.log(" this.siteConfig.favicon", this.siteConfig.favicona)
  },
  methods: {
    ...mapActions("kiriminaja", [
      "getSiteConfig",
    ]),
    ...mapActions("auth", ["login"]),
    ...mapMutations("auth", ["success", "saveListAccount"]),

    async validatePaste(val) {
      let pasted = await val.clipboardData.getData("text");
      setTimeout(() => {
        if (!parseInt(pasted)) {
          this.username = "";
        }
      });
    },
    showPassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.passwordIcon = "mdi-eye-off";
      } else {
        this.passwordType = "password";
        this.passwordIcon = "mdi-eye";
      }
    },
    onLogin() {
      this.listAccount = [];
      if (this.$refs.formLogin.validate()) {
        this.login({
          username: this.username,
          password: this.password
        }).then(data => {
          if (Array.isArray(data)) {
            this.listAccount = data;
            this.$refs.ModalAccount.modalShow();
          } else {
            this.selectAccount(data);
          }
        });
      }
    },
    selectAccount(data) {
      if (this.listAccount.length > 0) {
        this.saveListAccount(this.listAccount);
      }
      this.success(data);
      // const { redirect, source } = this.$route.query;
      // Pengecekan apakah halaman dibuka dari halaman utama atau tidak
      // if (redirect) {
      //   this.$router.push(redirect);
      // } else {
      // this.$router.push({
      //   name: "home"
      // });
      // window.location.href = `${process.env.VUE_APP_HOMEPAGE}login?token=${data.token}`
      const comeback = this.$route.query.comeback ? this.$route.query.comeback : "";
      window.location.replace(
        `${process.env.VUE_APP_HOMEPAGE}login?token=${data.token}${comeback ? "&comeback=" + comeback : ""}`
      );
      // }
      // if (source) {
      //   console.log('source is available');

      // } else { 
      // }
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Masuk");
  }
};
</script>
